import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { icons } from '../../../assets';
import { Tooltip } from 'antd';
// eslint-disable-next-line
export const UserPerfilAmaciceFresnillo = ({ grupo, nameUser, matricula, Fecha_y_hora }) => {
    const { arrayData } = useSelector((state) => state.table);
    const { typeAdmin } = useSelector((state) => state.auth)
    const [pointsUpper, setpointsUpper] = useState(0)
    const [timeTotalUser, setTimeTotalUser] = useState(0)
    const { proyectSelected } = useSelector((state) => state.vrlSlice);
    // const { proyects } = useSelector((state) => state.vrlSlice);
    const [pageSelected, setpageSelected] = useState(0)

    const { responses } = useSelector((state) => {
        if (typeAdmin === "VRT") {
            return state.vrtSlice
        }
        else {
            return state.vrlSlice
        }
    });
    // eslint-disable-next-line
    const [dataFilterPerUser, setFileterData] = useState([])

    const formatedDate = (date) => {
        const fecha = new Date(date);
        return fecha.toLocaleString('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
        });
    }


    const userHighPoints = (dataFilterPerUser) => {
        const element = dataFilterPerUser.reduce((max, elemento) =>
            parseInt(elemento.sumatoria) > parseInt(max.sumatoria) ? elemento : max, { sumatoria: '0/44' }
        );
        setpointsUpper(dataFilterPerUser.length ? element.sumatoria : 0);
    }

    const userTimeTotal = (dataFilterPerUser) => {
        const sumaTiempoTotal = dataFilterPerUser.reduce((total, elemento) => {
            const minutos = parseInt(elemento.tiempo_total.split(' ')[0], 10);
            return total + minutos;
        }, 0);
        const horas = Math.floor(sumaTiempoTotal / 60);
        const minutosRestantes = sumaTiempoTotal % 60;

        setTimeTotalUser(horas + ":" + minutosRestantes)
    }


    const onchangePage = (next) => {
        setpageSelected(actual => {
            const suma = actual + next
            if (suma >= dataFilterPerUser.length) {
                return 0
            }
            if (suma <= -1) {
                return dataFilterPerUser.length - 1
            }
            else {
                return suma
            }

        })
    }

    const contarPoints = (obj, keys) => {
        return keys.reduce((count, key) => count + (obj[key] !== "*" ? parseInt(obj[key]) : 0), 0);
    }

    useEffect(() => {

        // if (typeAdmin === "VRT" && proyectSelected === "66fafd1d92bbc20883798c43") {
        // console.log(arrayData)


        // historia 
        // marcaje 
        // aplicacion 
        const conjunts = arrayData
            .filter(obj => obj.matricula === matricula)
            .map(obj => ({
                ...obj,
                Fecha_y_hora: formatedDate(obj.Fecha_y_hora),
                d1: contarPoints(obj, ["D1_Semaforo_geomecanico", "D1_R1", "D1_R2", "D1_R3", "D1_R4", "D1_R5", "D1_R6"]),
                d2: contarPoints(obj, ["D2_Semaforo_geomecanico", "D2_Fortificacion", "D2_R1", "D2_R2", "D2_R3", "D2_R4", "D2_R5", "D2_R6", "D2_R7", "D2_R8"]),
                d3: contarPoints(obj, ["D3_Semaforo_geomecanico", "D3_Fortificacion", "D3_R1", "D3_R2", "D3_R3", "D3_R4", "D3_R5", "D3_R6", "D3_R7", "D3_R8", "D3_R9", "D3_R10", "D3_R11", "D3_R12"]),
                // d2: contarPoints(obj, ["Expedientes_HistoriaClinica", "Expedientes_HistoriasClinicas"]),
                // d3: contarPoints(obj, ["Unidad1_AplicacionCuello", "Unidad1_HistoriaClinica", "Unidad1_MarcajeCuello"]),

            }));
        console.log(conjunts)
        setFileterData(conjunts);
        userHighPoints(conjunts);
        userTimeTotal(conjunts)
    }, [responses, proyectSelected, arrayData, Fecha_y_hora, matricula, typeAdmin, nameUser])


    return (
        <div className='w-full h-full flex flex-col py-6 px-10'>
            <div className='pl-4 w-full h-5/12 flex items-center'>
                <div className='w-10 h-10 rounded-full flex justify-center items-center bg-blue-600 mr-4'>
                    <p className='text-white font-semibold text-xs'> {nameUser.split(" ")[0].substring(0, 2).toUpperCase()}</p>
                </div>
                <InfoUser title={"Nombre"} text={nameUser} />
                <InfoUser title={"Matrícula"} text={matricula} />
                {<InfoUser title={"Fecha"} text={new Date(Fecha_y_hora).toLocaleDateString('es-ES', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                })} />}
            </div>
            <div className="pl-16 pt-6">
                <p className='text-black text-2xl font-semibold leading-5'>Curso: {proyectSelected.name}</p>
            </div>
            <div className='w-full  flex h-12 justify-center gap-x-8 py-3'>
                <div className='flex w-[210px]'>
                    <img src={icons.watch} className='h-6 w-6' alt="icon time total" />
                    <div className='pl-2'>
                        <p className='text-xs text-[#686868] leading-5'>Tiempo total invertido</p>
                        <p className='text-xl font-medium text-[#282828] leading-5'>{timeTotalUser} hrs.</p>
                    </div>
                </div>
                <div className='flex w-[210px]'>
                    <img src={icons.shield} className='h-6 w-6' alt="icon time total" />
                    <div className='pl-2'>
                        <p className='text-xs text-[#686868] leading-5'>Puntaje más alto</p>
                        <p className='text-xl font-medium text-[#282828] leading-5'>{pointsUpper}</p>
                    </div>
                </div>

            </div>
            <div className="w-full flex justify-center items-center pt-4">
                {
                    dataFilterPerUser.length >= 2 &&
                    <div
                        onClick={() => { onchangePage(-1) }}
                        className='h-full flex justify-center items-center mr-4 cursor-pointer'>
                        <div className='w-10 h-10 rounded-full shadowBtnNext flex justify-center items-center'>
                            <img src={icons.mayorqueicon} className='h-6 transform rotate-180' alt="" />
                        </div>
                    </div>
                }
                {/*  */}
                <div className='w-[744px] h-[390px] rounded-3xl shadow-3xl py-8 px-4'>
                    <div className='flex w-full gap-4 pb-4'>
                        {/* <div className='flex gap-2'>
                            <img src={icons.initialDate} className="w-6 h-6" alt="icono de fecha" />
                            <div>
                                <p className='text-[#686868]'>Fecha inicial</p>
                                <p>{dataFilterPerUser[pageSelected]?.initialDate || 'Sin fecha'}</p>
                            </div>
                        </div> */}
                        <InfoIntent icon={icons.initialDate} title={'Fecha inicial'} data={dataFilterPerUser[pageSelected]?.Fecha_y_hora || 'Sin fecha'}></InfoIntent>
                        <InfoIntent icon={icons.endDate} title={'Fecha final'} data={dataFilterPerUser[pageSelected]?.Fecha_y_hora || 'Sin fecha'}></InfoIntent>
                        <div className='flex gap-2'>
                            <img src={icons.progress} className="w-6 h-6" alt="icono de fecha" />
                            <div>
                                <p className='text-[#686868] text-xs font-medium '>Estatus</p>
                                <div className='w-[112px] text-[#9A9A9A] text-xs font-normal leading-5'>
                                    <p className='w-[112px] text-center leading-5 py-1'>{dataFilterPerUser[pageSelected]?.Porcentaje_total || 'Sin progreso'}</p>
                                    <div className='w-full h-1 bg-[#d9d9d9] rounded'>
                                        <div
                                            style={{ width: dataFilterPerUser[pageSelected]?.Porcentaje_total || '0%' }}
                                            className={`h-full ${dataFilterPerUser[pageSelected]?.Porcentaje_total.split('%')[0] < 100 ? 'bg-[#F2B840]' : 'bg-[#89EB7E]'} `}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='flex gap-2'>
                            <img src={icons.progress} className="w-6 h-6" alt="icono de fecha" />
                            <div>
                                <p className='text-[#686868] text-xs font-medium '>Puntaje</p>
                                <div className='w-[112px] text-[#9A9A9A] text-xs font-normal leading-5'>
                                    <p className='w-[112px] text-center leading-5 py-1'>{dataFilterPerUser[pageSelected]?.sumatoria || 'Sin puntaje'}</p>
                                    <div className='w-full h-1 bg-[#d9d9d9] rounded'>
                                        <div
                                            style={{ width: (dataFilterPerUser[pageSelected]?.sumatoria * 100 / 44) + '%' || '0%' }}
                                            className={`h-full ${dataFilterPerUser[pageSelected]?.sumatoria < 44 ? 'bg-[#F2B840]' : 'bg-[#89EB7E]'} `}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <InfoIntent icon={icons.progress} title={'Progreso'} data={dataFilterPerUser[pageSelected]?.Porcentaje_total || 'Sin progreso'}></InfoIntent> */}
                        {/* <InfoIntent icon={icons.pointsSheld} title={'Puntaje'} data={dataFilterPerUser[pageSelected]?.puntaje || 'Sin puntaje'}></InfoIntent> */}
                    </div>
                    <div className='w-full h-10 bg-3366FF rounded flex'>
                        <div className='w-2/12 flex justify-start items-center px-2'>
                            <p className='text-white font-bold text-xs'>Módulos</p>
                        </div>
                        <div className='w-8/12 flex justify-center items-center'>
                            <p className='text-white font-bold text-xs'>Lecciones</p>
                        </div>
                        <div className='w-2/12 flex justify-center items-center'>
                            <p className='text-white font-bold text-xs'>Puntos</p>
                        </div>

                    </div>
                    {/* epp */}
                    <div className='w-full flex py-2'>
                        <div className='w-2/12 flex justify-start items-center px-2'>
                            <p className='text-xs font-medium text-[#686868]'>Desafío 1</p>
                        </div>
                        <div className='w-8/12 flex justify-center gap-2'>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D1_Semaforo_geomecanico === "2"} title={"D1_Semaforo_geomecanico"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D1_R1 === "1"} title={"D1_R1"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D1_R2 === "1"} title={"D1_R2"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D1_R3 === "1"} title={"D1_R3"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D1_R4 === "1"} title={"D1_R4"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D1_R5 === "1"} title={"D1_R5"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D1_R6 === "2"} title={"D1_R6"}></CubeIntent>
                            <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>
                            <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>
                            <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>
                            <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>
                            <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>
                            <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>
                            <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>
                        </div>
                        <div className='w-2/12 flex justify-center items-center px-2'>
                            <p className='text-xs font-medium text-[#686868]'>{dataFilterPerUser[pageSelected]?.d1 || '0'}</p>
                        </div>
                    </div>
                    <div className='w-full flex py-2'>
                        <div className='w-2/12 flex justify-start items-center px-2'>
                            <p className='text-xs font-medium text-[#686868]'>Desafío 2</p>
                        </div>
                        <div className='w-8/12 flex justify-center gap-2'>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D2_Semaforo_geomecanico === "2"} title={"D2_Semaforo_geomecanico"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D2_Fortificacion === "2"} title={"D2_Fortificacion"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D2_R1 === "1"} title={"D2_R1"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D2_R2 === "1"} title={"D2_R2"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D2_R3 === "1"} title={"D2_R3"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D2_R4 === "1"} title={"D2_R4"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D2_R5 === "1"} title={"D2_R5"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D2_R6 === "2"} title={"D2_R6"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D2_R7 === "2"} title={"D2_R7"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D2_R8 === "2"} title={"D2_R8"}></CubeIntent>
                            <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>
                            <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>
                            <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>
                            <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>
                        </div>
                        <div className='w-2/12 flex justify-center items-center px-2'>
                            <p className='text-xs font-medium text-[#686868]'>{dataFilterPerUser[pageSelected]?.d2 || '0'}</p>
                        </div>
                    </div>
                    <div className='w-full flex py-2'>
                        <div className='w-2/12 flex justify-start items-center px-2'>
                            <p className='text-xs font-medium text-[#686868]'>Desafío 3</p>
                        </div>
                        <div className='w-8/12 flex justify-center gap-2'>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D3_Semaforo_geomecanico === "2"} title={"D3_Semaforo_geomecanico"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D3_Fortificacion === "2"} title={"D3_Fortificacion"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D3_R1 === "1"} title={"D3_R1"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D3_R2 === "1"} title={"D3_R2"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D3_R3 === "1"} title={"D3_R3"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D3_R4 === "1"} title={"D3_R4"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D3_R5 === "1"} title={"D3_R5"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D3_R6 === "1"} title={"D3_R6"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D3_R7 === "1"} title={"D3_R7"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D3_R8 === "1"} title={"D3_R8"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D3_R9 === "2"} title={"D3_R9"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D3_R10 === "2"} title={"D3_R10"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D3_R11 === "2"} title={"D3_R11"}></CubeIntent>
                            <CubeIntent data={dataFilterPerUser[pageSelected]} correct={dataFilterPerUser[pageSelected]?.D3_R12 === "2"} title={"D3_R12"}></CubeIntent>
                        </div>
                        <div className='w-2/12 flex justify-center items-center px-2'>
                            <p className='text-xs font-medium text-[#686868]'>{dataFilterPerUser[pageSelected]?.d3 || '0'}</p>
                        </div>
                    </div>

                </div>
                {/*  */}
                {
                    dataFilterPerUser.length >= 2 &&
                    <div
                        onClick={() => { onchangePage(1) }}
                        className='h-full flex justify-center items-center pl-4 cursor-pointer'>
                        <div className='w-10 h-10 rounded-full shadowBtnNext flex justify-center items-center'>
                            <img src={icons.mayorqueicon} className='h-6 ' alt="" />
                        </div>
                    </div>
                }
            </div>
            <div className='w-full flex justify-center gap-x-2 pt-4'>
                {dataFilterPerUser.length >= 2 && <PageViewer pageSelected={pageSelected} dataFilterPerUser={dataFilterPerUser.length}></PageViewer>}

            </div>
        </div>
    )
}


const PageViewer = ({ pageSelected, dataFilterPerUser }) => {
    const rows = []
    for (let index = 0; index < dataFilterPerUser; index++) {
        rows.push(
            <div key={index} className={`w-2 h-2 
                ${pageSelected === index ? "bg-[#14A6E0] bg-opacity-100" : "bg-black bg-opacity-40"}
                 rounded-full`}></div>
        )
    }
    return rows
}

const InfoUser = ({ title, text }) => {
    return (
        <div className='w-2/6 h-full flex items-center'>
            <p className='text-[#686868]  text-xs font-medium leading-5'>{title}: </p>
            <p className='text-[#454545] text-xs font-normal pl-2 leading-5'>{text}</p>
        </div>
    )
}

const CubeIntent = ({ data, correct, title }) => {
    const color = data && data[title] !== "*" ?
        correct ? "bg-[#89EB7E]" : "bg-[#F2B840]"
        : "bg-red-500";

    return (
        <Tooltip placement="leftTop" title={
            <div className='bg-[#2A3A45]'>
                <p className='text-white'>{title}</p>
            </div>
        } color="#2A3A45" overlayInnerStyle={{ color: "#2A3A45" }}>

            <div className={`w-6 h-6 cursor-pointer rounded-[4px] flex justify-center items-center text-xs text-white font-semibold
                                    ${color}`}>

            </div>
        </Tooltip>
    )
}


const InfoIntent = ({ icon, title, data }) => {
    return (
        <div className='flex gap-2'>
            <img src={icon} className="w-6 h-6" alt="icono de fecha" />
            <div>
                <p className='text-[#686868] text-xs font-medium leading-5'>{title}</p>
                <p className='w-[112px] text-[#9A9A9A] text-xs font-normal leading-5'>{data}</p>
            </div>
        </div>
    )
}


export default UserPerfilAmaciceFresnillo
